import React from 'react';

const Salesforce = ({ color = '#335B70', ...props }) => (
    <svg {...props} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            d="M17.797 6.178c-.636 0-1.19.19-1.736.373-.636-1.1-1.826-1.827-3.108-1.827-1 0-1.909.454-2.554 1.09-.727-.909-1.827-1.554-3.1-1.554-2.118 0-3.936 1.736-3.936 3.854 0 .536.191 1.082.373 1.627A3.343 3.343 0 0 0 2 12.659c0 1.818 1.463 3.381 3.29 3.381.273 0 .546 0 .728-.09.363 1.372 1.736 2.38 3.38 2.38 1.546 0 2.828-.917 3.282-2.2.464.192.918.373 1.373.373a3.26 3.26 0 0 0 2.826-1.645c.282.073.573.073.828.073 2.372 0 4.29-1.9 4.29-4.363.09-2.454-1.818-4.39-4.2-4.39Z"
            fill={color}
        />
    </svg>
);

export default Salesforce;
